module.exports = __webpack_public_path__ + "img/0-18.6185d1c5.gif";